export const generateDataId = (prefix: string = null, value: string) => {
  return `${prefix ? `${prefix}-` : ""}${value
    ?.toString()
    .replace(/\s/g, "-")
    .toLowerCase()}`;
};
